import { render } from "./ModalItemDetail.vue?vue&type=template&id=a31df9d0&scoped=true"
import script from "./ModalItemDetail.vue?vue&type=script&lang=js"
export * from "./ModalItemDetail.vue?vue&type=script&lang=js"

import "./ModalItemDetail.vue?vue&type=style&index=0&id=a31df9d0&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31df9d0"]])

export default __exports__